<template>
    <div class="aldehyd-nachweis">
        <p>
            Silberspiegel-Probe<br />
            Tollens-Reagenz zeigt reduzierend wirkende Stoffe durch
            Silberspiegel-Bindung (alkalische Silbernitrat-Lösung)
            <br />
            R-CHl + 2 Ag<sup>+</sup> + 2 OH<sup>-</sup> → R-COH + 2 Ag +
            H<sub>2</sub>O
        </p>
    </div>
</template>

<script>
export default {
    name: 'aldehyd-nachweis',
};
</script>
